(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/app/betslipv2/views/betslip-header.js') >= 0) return;  svs.modules.push('/components/app/betslipv2/views/betslip-header.js'); (function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.app=_svs.app||{};
_svs.app.betslipv2=_svs.app.betslipv2||{};
_svs.app.betslipv2.templates=_svs.app.betslipv2.templates||{};
svs.app.betslipv2.templates.betslip_header = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    return "betslip-header-syndicate";
},"3":function(container,depth0,helpers,partials,data) {
    return "betslip-header-inner";
},"5":function(container,depth0,helpers,partials,data) {
    var helper;

  return "<div class=\"left bold\">"
    + container.escapeExpression(((helper = (helper = helpers.headerText || (depth0 != null ? depth0.headerText : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"headerText","hash":{},"data":data}) : helper)))
    + "</div>";
},"7":function(container,depth0,helpers,partials,data) {
    var helper;

  return "    <span class=\"left f-left betslip-header-syndicate-info\">\n        Du spelar för laget <br />\n        <span class=\"f-bold f-uppercase\">'"
    + container.escapeExpression(((helper = (helper = helpers.syndicateName || (depth0 != null ? depth0.syndicateName : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"syndicateName","hash":{},"data":data}) : helper)))
    + "'</span>.\n    </span>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {});

  return "<div class=\""
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.isSyndicate : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data})) != null ? stack1 : "")
    + "\">\n    "
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.headerText : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.isSyndicate : depth0),{"name":"if","hash":{},"fn":container.program(7, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "    <span class=\"close-label\">Stäng</span>\n    <i class=\"icon-default icon-100 icon-menu-down betslip-icon grey-500 f-800 right\" />\n</div>";
},"useData":true});
Handlebars.partials['components-app-betslipv2-betslip_header'] = svs.app.betslipv2.templates.betslip_header;
})(svs, Handlebars);

 })(window);